<p-toast></p-toast>
<app-preloader></app-preloader>
<router-outlet (activate)="onActivate($event)"></router-outlet>
